module.exports = "<modal class=\"ui-modal\"\r\n    ng-if=\"$ctrl.sesion_alarma\">\r\n  <fanconsultores-admin-sesion-alarma\r\n      expiracion=\"$ctrl.sesion_alarma\"\r\n      on-cancel=\"$ctrl.sesion_alarma = null\"></fanconsultores-admin-sesion-alarma>\r\n</modal>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/fanconsultores/admin/sesion/template.html
// module id = 2745
// module chunks = 0